module.exports = __webpack_public_path__ + "img/check-mark.1e55c651.svg";